import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import LoginModal from './LoginModal';
import MenuOptions from './MenuOptions';
import CreateSwapModal from './CreateSwapModal';

import { useIconSwapService } from './IconSwapService.jsx';

import logo from '../images/iconswap-logo.svg';
import createSwap from '../images/CreateSwap.svg';
import telegramIcon from '../images/TelegramIcon.png';
import dualIcons from '../images/DualIcon.png';

export const Navbar = () => {
  const { address } = useIconSwapService();
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const [isSwapModalOpen, setIsSwapModalOpen] = useState(false);

  useEffect(() => {
    if (!address) return;
    closeAuthModal();
  }, [address]);

  const openAuthModal = () => {
    setIsAuthModalOpen(true);
  };

  const closeAuthModal = () => {
    setIsAuthModalOpen(false);
  };

  const openSwapModal = () => {
    setIsSwapModalOpen(true);
  };

  const closeSwapModal = () => {
    setIsSwapModalOpen(false);
  };

  return (
    <>
      <NavbarWrapper>
        <Link to={'/'} style={{ textDecoration: 'none' }}>
          <Logo src={logo} alt="Logo"></Logo>
        </Link>
        <CreateSwapMargin>
          <CreateSwap
            onClick={() => (!address ? openAuthModal() : openSwapModal())}
          >
            <SwapImage src={createSwap} alt="createSwapButton" />
            <CreateSwapText>Create a swap</CreateSwapText>
          </CreateSwap>
        </CreateSwapMargin>
        <MenuOptions />
        <ProjectField>
          <DualIcons src={dualIcons} alt="dual icons" />
          <ProjectTextWrapper>
            <ProjectText>A P-Rep project</ProjectText>
            <ProjectText>collaboration between</ProjectText>
            <ProjectTextLastLine>
              <ATag href="https://iconpreps.com/preps/reliant-node-86f917">
                ReliantNode
              </ATag>{' '}
              &{' '}
              <ATag href="https://iconpreps.com/preps/icon-ation-cc6629">
                ICONation
              </ATag>
            </ProjectTextLastLine>
          </ProjectTextWrapper>
        </ProjectField>
        <TopGreyLine />
        <a href="https://t.me/iconswap">
          <TelegramButton>
            <TelegramImage src={telegramIcon} alt="telegram" />
            <TelegramButtonText>Join us on Telegram</TelegramButtonText>
          </TelegramButton>
        </a>
        <BottomGreyLine />
      </NavbarWrapper>
      <BottomPadding />
      <LoginModal isModalOpen={isAuthModalOpen} closeModal={closeAuthModal} />
      <CreateSwapModal
        isModalOpen={isSwapModalOpen}
        closeModal={closeSwapModal}
      />
    </>
  );
};

export default Navbar;

const NavbarWrapper = styled.div`
  padding-top: 100px;
  width: 250px;
  background-color: #fff;
  @media (max-width: 414px) {
    display: none;
  }
  height: 1470px;
  position: relative;
`;

const Logo = styled.img`
  margin-left: 66px;
  margin-right: 67px;
  @media (max-width: 414px) {
    display: none;
  }
  height: 97px;
  width: 117px;
`;

const SwapImage = styled.img`
  height: 40px;
  width: 40px;
  @media (max-width: 414px) {
    display: none;
  }
`;

const CreateSwapMargin = styled.div`
  height: 100px;
  width: 190px;
  margin-top: 49px;
  border-top-color: #e9ebec;
  border-top-width: 1px;
  border-top-style: solid;
  border-bottom-color: #e9ebec;
  border-bottom-width: 1px;
  border-bottom-style: solid;
  margin-left: 30px;
  margin-right: 30px;
  display: flex;
  align-items: center;
  margin-bottom: 50px;
  @media (max-width: 414px) {
    height: auto;
    width: auto;
    margin: auto;
    border: none;
    float: right;
    display: inline;
  }
`;

const CreateSwap = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  @media (max-width: 414px) {
    display: none;
  }
`;

const CreateSwapText = styled.div`
  color: #027d81;
  font-weight: bold;
  padding-left: 10px;
  @media (max-width: 414px) {
    display: none;
  }
`;

const ProjectField = styled.div`
  height: 136px;
  width: 210px;
  margin-left: 20px;
  margin-right: 20px;
  margin-top: 203px;
  position: absolute;
  bottom: 0;
  margin-bottom: 342px;
  border-radius: 18px;
  background-color: #faf8fa;
  @media (max-width: 414px) {
    display: none;
  }
`;

const DualIcons = styled.img`
  height: 60px;
  margin-top: -30px;
  margin-left: 10px;
`;

const ProjectTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 13px;
  margin-right: 10px;
  margin-left: 10px;
  margin-bottom: 23px;
`;

const ProjectText = styled.span`
  font-family: 'Avenir Next';
  font-size: 15px;
  line-height: 24px;
  font-weight: 500;
  letter-spacing: 0;
`;

const ProjectTextLastLine = styled.span`
  font-family: 'Avenir Next';
  font-size: 15px;
  line-height: 24px;
  font-weight: 600;
  letter-spacing: 0;
`;

const TelegramButton = styled.button`
  :focus {
    outline: none;
  }
  border: none;
  height: 50px;
  width: 190px;
  border-radius: 4px;
  margin-top: 40px;
  margin-bottom: 40px;
  position: absolute;
  bottom: 0;
  margin-left: 30px;
  margin-bottom: 192px;
  background-color: #ffffff;
  border: 1px solid #00888c;
  @media (max-width: 414px) {
    display: none;
  }
`;

const TelegramImage = styled.img`
  height: 25px;
  width: 25px;
  margin-right: 5px;
`;

const TelegramButtonText = styled.span`
  font-family: 'Avenir Next Medium';
  font-size: 15px;
  color: #00888c;
`;

const TopGreyLine = styled.hr`
  width: 190px;
  border-top: 1px solid #e8ebec;
  position: absolute;
  bottom: 0;
  margin-left: 29px;
  margin-bottom: 291px;
`;

const BottomGreyLine = styled.hr`
  width: 190px;
  border-top: 1px solid #e8ebec;
  position: absolute;
  bottom: 0;
  margin-left: 29px;
  margin-bottom: 141px;
`;

const ATag = styled.a`
  text-decoration: inherit;
  color: inherit;
`;

type ButtonToggleType = {
  buttonColor?: string;
  textColor?: string;
};

const BottomPadding = styled.div`
  width: 250px;
  background-color: #fff;
  @media (max-width: 414px) {
    display: none;
  }
`;
